import React from 'react';
import SectionHeader from './SectionHeader';
import NotesInput from './NotesInput';
import { computeRequestedDocuments } from './requestedDocs';

/**
 * Section 9 — Document Upload Summary.
 *
 * Displays the documents the advisor will need based on prior responses
 * and asks the client to acknowledge they'll upload them via the
 * Client Portal after submitting this form.
 *
 * @param {object} data       - Current section data.
 * @param {object} formData   - The full wizard formData (used to compute docs).
 * @param {string} portalUrl  - Optional Client Portal URL.
 */
export default function StepDocuments({ data, formData, onChange, portalUrl }) {
  const value = data || {};
  const docs = computeRequestedDocuments(formData || {});

  return (
    <div>
      <SectionHeader
        number={9}
        title="Documents to Upload"
        tip="After you submit, please use the secure Client Portal to
          upload any of the documents listed below. We'll add anything
          we still need to your file before the meeting."
        showAnnualNote={false}
        showAnnualNote={false}
      />

      {docs.length === 0 ? (
        <div className="alert alert-light border-start border-4 border-success">
          <i className="bi bi-check-circle me-2 text-success" />
          Based on your responses so far, we don't need any additional
          documents from you.
        </div>
      ) : (
        <div className="cashflow-section-card">
          <h6 className="cashflow-subsection-title">
            <i className="bi bi-paperclip me-2 text-danger" />
            Requested documents
          </h6>
          <ul className="mb-3">
            {docs.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>

          {portalUrl && (
            <a
              href={portalUrl}
              className="btn btn-outline-danger btn-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-cloud-upload me-1" />
              Open Client Portal in a new tab
            </a>
          )}

          <div className="form-check mt-3">
            <input
              id="portal_upload_acknowledged"
              className="form-check-input"
              type="checkbox"
              checked={!!value.portal_upload_acknowledged}
              onChange={(e) =>
                onChange({ ...value, portal_upload_acknowledged: e.target.checked })
              }
            />
            <label
              className="form-check-label small"
              htmlFor="portal_upload_acknowledged"
            >
              I'll upload the requested documents to my Client Portal.
            </label>
          </div>
        </div>
      )}

      <NotesInput
        value={value.notes}
        onChange={(v) => onChange({ ...value, notes: v })}
      />
    </div>
  );
}
